import useTranslation from "@hooks/use_translation";
import { Body, SectionHeader } from "@sprout/typography";
import Fingerprint1Green from "@images/fingerprint_1_green.svg";

const ProfileBanner = () => {
  const { t } = useTranslation("user", { keyPrefix: "profile_banner" });

  return (
    <div className="relative overflow-hidden w-full bg-green-100">
      <div className="relative mx-auto max-w-[1550px] py-6 px-6 md:py-10 md:px-[52px]">
        <img
          src={Fingerprint1Green}
          alt=""
          aria-hidden
          className="pointer-events-none select-none absolute hidden -top-[187px] w-[600px] h-[600px] right-0 md:block"
        />
        <div className="relative flex flex-col items-start gap-3 max-w-3xl">
          <SectionHeader serif as="h1" className="pt-0! md:text-[2rem]! md:leading-10!">
            {t("title")}
          </SectionHeader>
          <Body className="text-sm! leading-5! md:text-base! md:leading-6!">{t("subtitle")}</Body>
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;
